import UserForm from "@/components/forms/UserForm";
import React from "react";

const EditUserPage = () => {
  return <UserForm edit />;
};

export default EditUserPage;
